import React, { useState } from 'react';
import '../../styles/accordian.css';


function Accordion({ title, children, defaultOpen = false, className = "" }) {
    const [open, setOpen] = React.useState(defaultOpen);
  
    return (
      <div className={`accordion ${className}`}>
        <div
          className="accordion-header"
          onClick={() => setOpen(!open)}
          style={{ cursor: "pointer" }}
        >
          <strong>{title}</strong>
          <span>{open ? "−" : "+"}</span>
        </div>
  
        {open && <div className="accordion-body">{children}</div>}
      </div>
    );
  }

  export default Accordion;